window.UpperLetter = function (e) {
    if (e.key == "_") return false;
    return !/^[0-9!-\/:-@[-`{-~_]+$/i.test(e.key)
}

window.isTRChar = function(key) {
    var trchar = [231, 246, 252, 287, 305, 351];
    for (var i = 0; i < trchar.length; i++) {
        if (trchar[i] == key)
            return true;
    }
    return false;
}

window.UpperLetterBlur = function (e, clear) {
    if (e.key == "_") return false;
    return !/^[0-9!-\/:-@[-`{-~_]+$/i.test(e.key)
}





